export default __webpack_public_path__ + "static/media/iconCross.97c98e3f.svg";